
import { useNavigate, useParams } from "react-router-dom";
import { DetallesDeGasto, FormCrearAbonosGastos, TablaAbonosFactura } from "../components";
import { CargandoMedio, ModalFormulario } from "../../components";
import { LayoutDesplegable } from "../../layouts";
import { iconos } from "../../../data";
import { useModalStore } from "../../../stores";
import { useGastoXID } from "../../../hooks/cache";
import { useAbonosXGastos } from "../../../hooks/cache/ops/useAbonosXGastos";




export const AbonosGastos = () => {


    const { id } = useParams();
    const navigate = useNavigate();
    const { data } = useGastoXID(id);
    const { data:abonosGastos, isLoading } = useAbonosXGastos(id);
    const { modalFormToggle } = useModalStore();
    
    
    

    const menu = [ 
        { title: 'Crear Abono', action:() => modalFormToggle(true), icon: iconos['plus'] },
        { title: 'Pagina Anterior', action:() => navigate(-1), icon: iconos['back'] },
    ];



    return (

        <LayoutDesplegable titulo="Abonos a Gastos" subtitulo={`Información gasto: ${(data?.factura) ? data.factura : 'Cargando...'}`} menu={menu}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de abonos a gastos..." />
            :   <>
                <DetallesDeGasto />
                <TablaAbonosFactura data={ abonosGastos || []} />
                </>
            }

            <ModalFormulario titulo="Crear Abono" valor={{}} onClose={() => modalFormToggle(false)}>
                <FormCrearAbonosGastos />
            </ModalFormulario>
        </LayoutDesplegable>

    )
}
